var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6 6.11347C1.6 3.62075 3.62075 1.6 6.11347 1.6C8.60618 1.6 10.6269 3.62075 10.6269 6.11347C10.6269 7.34671 10.1323 8.46444 9.33064 9.27909C9.32174 9.28722 9.31299 9.29559 9.30438 9.3042C9.29577 9.31281 9.28739 9.32158 9.27926 9.33047C8.46459 10.1322 7.3468 10.6269 6.11347 10.6269C3.62075 10.6269 1.6 8.60618 1.6 6.11347ZM9.83381 10.965C8.80325 11.7565 7.5133 12.2269 6.11347 12.2269C2.73709 12.2269 0 9.48984 0 6.11347C0 2.73709 2.73709 0 6.11347 0C9.48984 0 12.2269 2.73709 12.2269 6.11347C12.2269 7.51321 11.7565 8.80307 10.9652 9.8336L13.7638 12.6322C14.0762 12.9446 14.0762 13.4512 13.7638 13.7636C13.4513 14.076 12.9448 14.076 12.6324 13.7636L9.83381 10.965Z",
    fill: "#222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.86775c3f992099ad7c453da59e5c7a1d.svg";
export { ForwardRef as ReactComponent };